import * as React from 'react'

import { ItemCountup } from '@thg-commerce/enterprise-widget-itemcountup'

export interface TutorialItem {
  title: string
  content: string
  images: {
    src: { url: string }[]
    alt: string
  }[]
}
export interface TutorialRendererProps {
  isAmp: boolean
  items: TutorialItem[]
}

export const TutorialRenderer = (props: TutorialRendererProps) => {
  const itemCountupItems = props.items.map((item: TutorialItem) => ({
    title: item.title,
    content: item.content,
    images: item.images.map((image) => ({
      src: image.src[0].url,
      alt: image.alt,
    })),
  }))

  return <ItemCountup items={itemCountupItems} isAmp={props.isAmp} />
}
